import { MHC, MHCWithVaccination } from '../store/types/medicalHistory';
import { GET_PT_MED_HISTORY } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface DocGinieProfileResponse {
    success: string;
    error?: string;
    data?: MHCWithVaccination;
}

export default (docOId: string, ptId: string): Promise<DocGinieProfileResponse> =>
    fetchWithRefresh(GET_PT_MED_HISTORY(docOId, ptId)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to fetch med history');
        }
    });
